var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolDataTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.9907 49.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m23.8282.0283C10.0382.6679-.6219,12.3779.0282,26.1679c.5999,12.8901,10.9099,23.1899,23.7899,23.8003,13.84.6099,25.54-10.1104,26.15-23.9399.03-.7305.03-1.4702,0-2.2002C49.3181,10.0283,37.6181-.6221,23.8282.0283Zm16.52,22.21c-.05.75-.6801,1.3296-1.42,1.3296-.04,0-.0699,0-.1-.0098-.78-.0601-1.38-.7402-1.3199-1.52l.33-4.46-10.3099,11.9297c-.25.29-.6001.4702-.9701.4902-.38.04-.75-.1001-1.0299-.3398l-4.1501-3.5801-9.8899,11.4399c-.28.3301-.6801.4897-1.0801.4897-.3199,0-.6499-.1099-.9299-.3398-.5901-.5098-.65-1.4199-.14-2.0098l10.8099-12.52c.52-.5903,1.42-.6602,2.02-.1499l4.13,3.5796,9.37-10.8496-4.35.9697c-.77.1699-1.5299-.3198-1.7001-1.0801-.1699-.77.3101-1.5298,1.0801-1.6997l8.55-1.9004c.45-.0898.9099.0205,1.25.3101.34.3003.52.73.49,1.1899l-.64,8.7305Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDataTrend);
export default __webpack_public_path__ + "static/media/symbol-data-trend.beb18cc844a316f859f0fc973e421f37.svg";
export { ForwardRef as ReactComponent };